module.exports = __webpack_public_path__ + "img/7.cc1b46b5.webp";